import React from 'react';
import { Card, CardHeader, CardBody, Row, Col, Button, Table, Badge } from 'reactstrap';

const ClassDayCard = ({ 
  slot, 
  alumnos, 
  isAdmin, 
  asistenciaDisplay, 
  onOpenModal, 
  onOpenCancelModal, 
  onOpenAsistenciaModal, 
  onOpenDetalleModal 
}) => {
  const cupoLleno = slot.booked >= slot.capacity;
  const hora = new Date(slot.start).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return (
    <Card className="mb-4 shadow-sm">
      <CardHeader className="bg-light">
        <Row>
          <Col md="6">
            <h5 className="mb-0">{slot.class_type || "Clase"}</h5>
            <small className="text-muted">Horario: {hora}</small>
          </Col>
          <Col md="6" className="text-right">
            <Badge color={cupoLleno ? "danger" : "success"}>
              {cupoLleno ? "Clase llena" : `Reservas: ${slot.booked}/${slot.capacity}`}
            </Badge>{" "}
            <span className="ml-3" style={{ fontSize: "0.8rem" }}>
              {slot.capacity - slot.booked} cupos disponibles
            </span>
            <span className="ml-3">Coach: {slot.coach}</span>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Table hover responsive className="mb-3">
          <thead className="thead-light">
            <tr>
              <th>Alumno</th>
              <th>Membresia</th>
              <th>Asistencia</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.length > 0 ? (
              alumnos.map((b) => (
                <tr key={b.id}>
                  <td>
                    <span
                      style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                      onClick={() => onOpenDetalleModal(b)}
                    >
                      {b.client}
                    </span>
                  </td>
                  <td>
                    {/* Debug: mostrar datos recibidos */}
                    {console.log('Booking data for', b.client, ':', {
                      membership: b.membership,
                      client_active_membership: b.client_active_membership
                    })}
                    
                    {!b.client_active_membership || b.client_active_membership === "-" || b.client_active_membership === null ? 
                      "Sin Membresia Activa" : 
                      b.client_active_membership
                    }
                    {/* Mostrar también la membresía específica del booking si es diferente */}
                    {b.membership && b.membership !== b.client_active_membership && (
                      <small className="text-muted d-block">
                        (Booking: {b.membership})
                      </small>
                    )}
                  </td>
                  <td>
                    <Badge color={asistenciaDisplay[b.attendance_status?.toLowerCase()?.trim()]?.color || "secondary"}>
                      {asistenciaDisplay[b.attendance_status?.toLowerCase()?.trim()]?.label || "Desconocido"}
                    </Badge>
                  </td>
                  <td>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => onOpenCancelModal(b)}
                      className="btn-cerrar"
                    >
                      Cancelar
                    </Button>
                    {isAdmin && (
                      <Button
                        size="sm"
                        style={{ marginLeft: "10px" }}
                        onClick={() => onOpenAsistenciaModal(b)}
                        className="btn-importar"
                      >
                        Editar asistencia
                      </Button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="3" className="text-muted">No hay reservas aún.</td></tr>
            )}
          </tbody>
        </Table>
        <Button
          color={cupoLleno ? "secondary" : "primary"}
          size="sm"
          onClick={() => onOpenModal(slot)}
          disabled={cupoLleno}
          className="btn-anadir"
        >
          Añadir alumno
        </Button>
      </CardBody>
    </Card>
  );
};

export default ClassDayCard;
